import { defineComponent as _defineComponent } from 'vue'
import consola from 'consola'


export default /*#__PURE__*/_defineComponent({
  __name: 'ImageMedia',
  props: {
    src: null,
    alt: null,
    original: { type: Boolean },
    placeholder: null,
    isDetail: { type: Boolean },
    isDarkMode: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  src?: string
  alt?: string
  original: boolean
  placeholder: string
  isDetail?: boolean
  isDarkMode?: boolean
}



const onError = (e: Event) => {
  const target = e.target as HTMLImageElement
  if (target) {
    consola.log('[KODADOT::IMAGE] unable to load', props.src, e)
    target.src = props.placeholder
  }
}

return { __sfc: true,props, onError }
}

})